module.exports = __webpack_public_path__ + "static/media/add doctor.d9d5a769.svg";